// @flow
import imagesActionKeys from './imagesActionKeys';
import imagesService from './imagesService';
import type {
  AddImagesRequest,
  GetPhotosRequest,
  GetPhotosResponse,
  RemoveImagesRequest,
  ServiceProviderImage,
  UpdateImageRequest,
} from './imagesService';

const addImages = (images: AddImagesRequest): {|
  meta: {|serviceProviderId: number | string|},
  payload: {|
    data: AddImagesRequest,
    promise: Promise<Array<ServiceProviderImage>>,
  |},
  type: string,
|} => ({
  type: imagesActionKeys.ADD_IMAGES,
  payload: {
    data: images,
    promise: imagesService.addImages(images),
  },
  meta: {
    serviceProviderId: images.serviceProviderId,
  },
});

const resetAddImages = (): {|type: string|} => ({
  type: imagesActionKeys.ADD_IMAGES_RESET,
});

const updateImage = (image: UpdateImageRequest): {|
  meta: {|serviceProviderId: number | string|},
  payload: {|
    data: UpdateImageRequest,
    promise: Promise<ServiceProviderImage>,
  |},
  type: string,
|} => ({
  type: imagesActionKeys.UPDATE_IMAGES,
  payload: {
    data: image,
    promise: imagesService.updateImage(image),
  },
  meta: {
    serviceProviderId: image.serviceProviderId,
  },
});

const resetUpdateImage = (): {|type: string|} => ({
  type: imagesActionKeys.UPDATE_IMAGES_RESET,
});

export type RemoveImagesAction = {
  meta: RemoveImagesRequest,
  payload: any
};

const removeImages = ({
  uuid,
  serviceProviderId,
  imageIds,
}: RemoveImagesRequest): RemoveImagesAction => ({
  type: imagesActionKeys.REMOVE_IMAGES,
  payload: {
    data: { uuid, imageIds },
    promise: imagesService.removeImages({ uuid, serviceProviderId, imageIds }),
  },
  meta: {
    uuid,
    serviceProviderId,
    imageIds,
  },
});

export type ShowConfirmRemoveImageAction = {
  payload: ServiceProviderImage
};

const showConfirmRemoveImage = (image: ServiceProviderImage): ShowConfirmRemoveImageAction => ({
  type: imagesActionKeys.SHOW_CONFIRM_REMOVE_IMAGE,
  payload: image,
});

const hideConfirmRemoveImage = (): {|type: string|} => ({
  type: imagesActionKeys.HIDE_CONFIRM_REMOVE_IMAGE,
});

const getPhotos = ({ uuid, limit, offset }: GetPhotosRequest): {|
  payload: {|
    data: {|limit: number, offset: number, uuid: string|},
    promise: Promise<GetPhotosResponse>,
  |},
  type: string,
|} => ({
  type: imagesActionKeys.GET_PHOTOS,
  payload: {
    data: { uuid, limit, offset },
    promise: imagesService.getPhotos({ uuid, limit, offset }),
  },
});

export const getCoverPhoto =
  (UAPI_UUID: string): {|
    payload: {|
      data: {|
        UAPI_UUID: string,
      |},
      promise: Promise<any>,
    |},
    type: any,
  |} => ({
    type: imagesActionKeys.GET_COVER_PHOTO,
    payload: {
      data: {
        UAPI_UUID,
      },
      promise: imagesService.getCoverPhoto(UAPI_UUID),
    },
  });

const createCoverPhoto =
  (UAPI_UUID: string, file: Object, serviceProviderId: string | number): {|
    meta: {|serviceProviderId: number | string|},
    payload: {|
      data: {|
        UAPI_UUID: string,
        file: Object,
        serviceProviderId: string | number;
      |},
      promise: Promise<any>,
    |},
    type: any,
  |} => ({
    type: imagesActionKeys.CREATE_COVER_PHOTO,
    payload: {
      data: {
        UAPI_UUID,
        file,
        serviceProviderId,
      },
      promise: imagesService.saveSinglePhoto(UAPI_UUID, serviceProviderId, 'cover', file),
    },
    meta: {
      serviceProviderId,
    },
  });

const saveCompanyLogo =
  (serviceProviderId: string | number, file: Object): {|
    payload: {|
      data: {|file: any, serviceProviderId: string | number|},
      promise: Promise<any>,
    |},
    type: any,
  |} => ({
    type: imagesActionKeys.SAVE_LOGO,
    payload: {
      data: { serviceProviderId, file },
      promise: imagesService.saveSinglePhoto('uuid', serviceProviderId, 'logo', file),
    },
  });

export default {
  addImages,
  resetAddImages,
  updateImage,
  resetUpdateImage,
  getPhotos,
  removeImages,
  showConfirmRemoveImage,
  hideConfirmRemoveImage,
  getCoverPhoto,
  createCoverPhoto,
  saveCompanyLogo,
};



// WEBPACK FOOTER //
// ./src/app/common/images/imagesActions.js